<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      class="modal-detail"
      persistent
      :fullscreen="$vuetify.breakpoint.mdAndDown"
      max-width="900px"
    >
      <v-card>
        <div class="d-flex justify-space-between align-center memory-bit-banner">
          <div class="avatar-infos">
            <v-avatar size="50">
              <v-img :src="$store.getters.avatarUrl"></v-img>
            </v-avatar>
            <span>&nbsp;&nbsp;{{ user.name }}</span>
          </div>

          <span class="text-center mx-auto">
            <!-- {{ getCategoryName(modals.file.categories) }} -->
            <small class="txt-date text-muted text-center mx-auto">{{ $t("Memory Bit / ") }}{{ formatDate(modals.file.updated_at.split('T')[0]) }}</small>
          </span>
        </div>
        <v-divider></v-divider>
        <h5
          class="text-h5 text-muted text-left mx-auto mt-8 ml-30"
          :class="{'modal-details--text-h5': textStatus }"
        >
          {{ modals.file.name }}
        </h5>
        <div class="dialog-body">
          <v-card-text gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
            <v-container
              v-if="deletingFile"
              style="height: 400px;"
            >
              <v-row
                class="fill-height"
                align-content="center"
                justify="center"
              >
                <v-col
                  v-if="!loading"
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  {{ result ? $t("The content has been deleted.") : $t("Are you sure you want to delete this content?") }}
                </v-col>
                <v-col
                  v-if="!loading && !result"
                  cols="12"
                  class="justify-content-center wrapper-buttons-center"
                >
                  <v-btn
                    color="primary"
                    @click="submitDelete(modals.file.id, modals.file.url)"
                  >
                    {{ $t("\n                    Delete\n                  ") }}
                  </v-btn>
                  <v-btn @click="closeModal(true)">
                    {{ $t("\n                    Cancel\n                  ") }}
                  </v-btn>
                </v-col>

                <v-col
                  v-if="loading"
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  {{ $t("\n                  Deleting content...\n                ") }}
                </v-col>
                <v-col
                  v-if="loading"
                  cols="6"
                >
                  <v-progress-linear
                    color="primary accent-4"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>

            <v-container v-if="!deletingFile">
              <div
                v-if="modals.file"
                class="modal-picture-details"
                :class="{'static-detail': textStatus }"
              >
                <div class="container">
                  <div
                    v-show="!fbConverting"
                    class="row justify-content-center"
                  >
                    <div class="col-lg-6">
                      <div class="click-region">
                        <div
                          v-if="parseInt(modals.file.categories, 10) === 1"
                          class="flag-container"
                        >
                          <div class="flag">
                            {{ $t("\n                            Draft\n                          ") }}
                          </div>
                        </div>
                        <div v-if="modals.file.view_type && modals.file.related_files.length > 1">
                          <img
                            v-if="isImage(modals.file.related_files[0])"
                            :src="getDisplayUrl(0)"
                            :class="`rotate_images__position_${modals.file.rotate_position[0]}`"
                            @error="onImgError(modals.file.related_files[0])"
                          />
                          <ListVideo
                            v-else-if="isVideo(modals.file.related_files[0])"
                            preload="metadata"
                            :poster="videoPosterUrl(modals.file.related_files[0], modals.file)"
                            width="100%"
                            height="100%"
                            controls
                          >
                            <source
                              :src="modals.file.related_files[0]"
                              type="video/mp4"
                            >{{ $t("\n                            Your browser does not support the video tag.\n                          ") }}
                          </ListVideo>
                        </div>
                        <div v-else>
                          <!-- cycle -->
                          <v-carousel
                            v-if="modals.file.related_files.length > 1"
                            v-model="currentIndex"
                          >
                            <v-carousel-item
                              v-for="(item,i) in modals.file.related_files"
                              :key="i"
                            >
                              <img
                                v-if="isImage(item)"
                                :src="getDisplayUrl(i)"
                                :class="`rotate_images__position_${modals.file.rotate_position[i]}`"
                                @click="emitOpenZoom()"
                                @error="onImgError(item)"
                              />
                              <ListVideo
                                v-else-if="isVideo(item)"
                                preload="metadata"
                                :poster="videoPosterUrl(item, modals.file)"
                                width="100%"
                                height="100%"
                                controls
                              >
                                <source
                                  :src="item"
                                  type="video/mp4"
                                >{{ $t("\n                                Your browser does not support the video tag.\n                              ") }}
                              </ListVideo>
                            </v-carousel-item>
                          </v-carousel>
                          <div v-else>
                            <img
                              v-if="isImage(modals.file.related_files[0])"
                              :src="getDisplayUrl(0)"
                              :class="`rotate_images__position_${modals.file.rotate_position[0]}`"
                              @click="emitOpenZoom()"
                              @error="onImgError(modals.file.related_files[0])"
                            />
                            <ListVideo
                              v-else-if="isVideo(modals.file.related_files[0])"
                              preload="metadata"
                              :poster="videoPosterUrl(modals.file.related_files[0], modals.file)"
                              width="100%"
                              height="100%"
                              controls
                            >
                              <source
                                :src="modals.file.related_files[0]"
                                type="video/mp4"
                              >{{ $t("\n                              Your browser does not support the video tag.\n                            ") }}
                            </ListVideo>
                          </div>
                        </div>
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="primary"
                          @click="emitOpenZoom()"
                        >
                          <v-icon
                            right
                            dark
                            class="mx-auto"
                          >
                            {{ modals.file.view_type? mdiBookOpenVariant : mdiMagnifyScan }}
                          </v-icon>
                        </v-btn>
                      </div>
                      <!-- Restore in progress -->
                      <div
                        v-if="restoring"
                        class="restore-loading"
                      >
                        <v-progress-circular
                          :size="50"
                          :width="5"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                        <p class="mt-3 text-center">
                          {{ $t("\n                          Restoring image...\n                        ") }}
                        </p>
                      </div>
                      <!-- Image Variations Thumbnails -->
                      <div
                        v-if="currentVariationData() && currentVariationData().variations.length > 0"
                        class="variations-section"
                      >
                        <div class="variations-label">
                          {{ $t("\n                          Image Versions\n                        ") }}
                        </div>
                        <div class="variations-thumbnails">
                          <div class="variation-thumb-wrapper">
                            <img
                              :src="currentVariationData().original_url"
                              class="variation-thumb"
                              :class="{ 'variation-active': isVariationSelected('original') }"
                              @click="selectVariation('original')"
                            />
                            <div class="variation-thumb-label">
                              <span>{{ $t("Original") }}</span>
                              <v-icon
                                x-small
                                :color="!currentVariationData().variations.some(v => v.is_default) ? 'primary' : 'grey'"
                                @click="setDefaultVariation(currentVariationData().files_link_id, false)"
                              >
                                {{ !currentVariationData().variations.some(v => v.is_default) ? mdiStar : mdiStarOutline }}
                              </v-icon>
                            </div>
                          </div>
                          <div
                            v-for="variation in currentVariationData().variations"
                            :key="variation.id"
                            class="variation-thumb-wrapper"
                          >
                            <img
                              :src="variation.url"
                              class="variation-thumb"
                              :class="{ 'variation-active': isVariationSelected('restored') }"
                              @click="selectVariation('restored')"
                            />
                            <div class="variation-thumb-label">
                              <span>{{ $t("Restored") }}</span>
                              <v-icon
                                x-small
                                :color="variation.is_default ? 'primary' : 'grey'"
                                @click="setDefaultVariation(currentVariationData().files_link_id, true)"
                              >
                                {{ variation.is_default ? mdiStar : mdiStarOutline }}
                              </v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 wrapper-copy">
                      <div
                        v-if="actions"
                        class="wrapper-icons"
                      >
                        <v-icon
                          v-if="!deletingFile"
                          :class="{'alternate-icon-small': !mdiTrashCan}"
                          class="icon-trash"
                          @click="deleteFile(true)"
                        >
                          {{ mdiTrashCan }}
                        </v-icon>
                        <v-icon
                          v-if="(!deletingFile && !$vuetify.breakpoint.mdAndDown)"
                          :class="{'alternate-icon-small': !mdiSquareEditOutline}"
                          class="icon-edit"
                          @click="$emit('openEdit', modals)"
                        >
                          {{ mdiSquareEditOutline }}
                        </v-icon>
                        <v-tooltip
                          v-if="!deletingFile"
                          top
                          color="#000000"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-btn
                                text
                                small
                                :loading="restoring"
                                :disabled="!photoToolsAvailable || restoring"
                                @click="restoreImage()"
                              >
                                <v-icon
                                  small
                                  left
                                >
                                  {{ mdiAutoFix }}
                                </v-icon>{{ $t("\n                              Restore · 5 credits\n                            ") }}</v-btn>
                            </span>
                          </template>
                          <span>{{ photoToolsAvailable ? $t("Restore / Enhance Image · 5 credits · needs 25 MB free while processing") : 'Select a photo to restore or enhance it.' }}</span>
                        </v-tooltip>
                        <v-tooltip
                          v-if="!deletingFile"
                          top
                          color="#000000"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-btn
                                text
                                small
                                :disabled="!photoToolsAvailable || restoring"
                                @click="openAnimation()"
                              >{{ $t("\n                              Animate photo\n                            ") }}</v-btn>
                            </span>
                          </template>
                          <span>{{ photoToolsAvailable ? $t("Bring this photo to life.") : 'Select a photo to animate it.' }}</span>
                        </v-tooltip>
                      </div>
                      <v-alert
                        v-if="restoreMessage"
                        dense
                        outlined
                        :type="restoreFailed ? 'error' : 'success'"
                        role="status"
                      >
                        {{ restoreMessage }}
                      </v-alert>
                      <div
                        v-if="textStatus"
                        class="wrapper-text clearfix"
                      >
                        <div class="d-flex align-center mb-2">
                          <AiTextActions
                            :value="modals.file.alternative_text"
                            :original-text.sync="originalText"
                            @input="onAiTextUpdate($event)"
                          />
                          <v-progress-circular
                            v-if="savingText"
                            :size="18"
                            :width="2"
                            color="primary"
                            indeterminate
                            class="ml-2"
                          ></v-progress-circular>
                          <span
                            v-if="savingText"
                            class="ml-1 text-caption text--secondary"
                          >{{ $t("Saving...") }}</span>
                        </div>
                        <div
                          class="inner-text"
                          v-html="modals.file.alternative_text"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
            <RecordPrivacy
              v-if="actions"
              :record="modals.file"
              class="mr-2"
            />
            <a
              v-if="$vuetify.breakpoint.mdAndDown"
              href="javascript:;"
              class="lnk-read-more"
              @click="showText()"
            >{{ $t("Read more") }}</a>
          </v-card-text>
          <CommentsSection
            v-if="modals.file && modals.file.id"
            :file-id="modals.file.id"
            @count-updated="commentCount = $event"
          />
        </div>
        <v-divider class="detail-divider"></v-divider>
        <v-card-actions>
          <template v-if="actions">
            <v-btn
              v-if="shareAvailable && ((!textStatus && $vuetify.breakpoint.mdAndDown) || !$vuetify.breakpoint.mdAndDown)"
              color="primary"
              class="share-memory"
              @click="shareOpen = true"
            >
              {{ $t('Share memory') }}
            </v-btn>
            <v-spacer></v-spacer>
            <div
              v-if="(!textStatus && $vuetify.breakpoint.mdAndDown) || !$vuetify.breakpoint.mdAndDown"
              class="action-icons"
            >
              <div
                class="like-action"
              >
                <v-icon
                  :class="{'alternate-icon-small': !mdiHeartOutline, 'liked': isLiked}"
                  class="mx-auto icon-heart"
                  :color="isLiked ? 'red' : ''"
                  @click="toggleLike"
                >
                  {{ isLiked ? mdiHeart : mdiHeartOutline }}
                </v-icon>
                <span
                  v-if="likeCount > 0"
                  class="like-count cursor-pointer"
                  @click="openLikersDialog"
                >{{ likeCount }}</span>
              </div>
              <div class="comment-action">
                <v-icon
                  :class="{'alternate-icon-small': !mdiCommentTextMultipleOutline }"
                  class="mx-auto icon-comments"
                >
                  {{ mdiCommentTextMultipleOutline }}
                </v-icon>
                <span
                  v-if="commentCount > 0"
                  class="like-count ml-1"
                >{{ commentCount }}</span>
              </div>
              <v-icon
                v-if="shareAvailable"
                :class="{'alternate-icon-small': !mdiShareVariantOutline }"
                class="mx-auto icon-share"
                :aria-label="$t('Share memory')"
                @click="shareOpen = true"
              >
                {{ mdiShareVariantOutline }}
              </v-icon>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!loading"
              class="close-btn"
              @click.stop="closeModal(result)"
            >
              {{ $t("\n              Close\n            ") }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalShareRequest
      v-if="shareOpen && shareAvailable"
      :modals="modals"
      :section="shareSection"
      @close="shareOpen = false"
    />
    <LikersDialog
      v-model="likersDialogOpen"
      :file-id="likersDialogFileId"
    />
    <PhotoAnimationDialog
      v-if="actions && currentFileLinkId() && animationDialog"
      v-model="animationDialog"
      :file-link-id="currentFileLinkId()"
      :source-version="isVariationSelected('restored') ? 'restored' : 'original'"
      :photo-url="getDisplayUrl(currentIndex)"
      @generated="onAnimationCreated"
    />
  </v-row>
</template>

<script>

import axios from 'axios'
import {
  mdiMagnifyScan, mdiBookOpenVariant, mdiCropRotate, mdiSquareEditOutline, mdiTrashCan, mdiHeartOutline, mdiHeart, mdiCommentTextMultipleOutline, mdiShareVariantOutline,
  mdiAutoFix, mdiStar, mdiStarOutline,
} from '@mdi/js'
import { t } from '@/i18n'
import { canShareRecord } from '@/utils/publicShare'
import ModalShareRequest from '@/components/modals/ModalShareRequest.vue'
import LikersDialog from '@/components/LikersDialog.vue'
import CommentsSection from '@/components/CommentsSection.vue'
import AiTextActions from '@/components/AiTextActions.vue'
import PhotoAnimationDialog from '@/components/PhotoAnimationDialog.vue'
import ListVideo from '@/components/ListVideo.vue'
import { videoPosterUrl } from '@/utils/videoPreview'
import { runAi, aiError } from '@/services/ai'

import RecordPrivacy from '../RecordPrivacy.vue'

export default {
  components: {
    ListVideo,
    RecordPrivacy,
    ModalShareRequest,
    LikersDialog,
    CommentsSection,
    AiTextActions,
    PhotoAnimationDialog,
  },
  props: ['modals', 'actions', 'categoriesName', 'categoriesId', 'shareSection'],
  data() {
    return {
      mdiMagnifyScan,
      mdiCropRotate,
      mdiBookOpenVariant,
      mdiSquareEditOutline,
      mdiTrashCan,
      mdiHeartOutline,
      mdiHeart,
      mdiCommentTextMultipleOutline,
      mdiShareVariantOutline,
      mdiAutoFix,
      mdiStar,
      mdiStarOutline,
      textStatus: false,
      shareOpen: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',	'July',	'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      deletingFile: false,
      dialog: true,
      fbConverting: false,
      endpoint: process.env.VUE_APP_ROOT_API,
      loading: true,
      result: false,
      currentIndex: 0,
      failedImages: {},
      isLiked: false,
      likeCount: 0,
      likingInProgress: false,
      likersDialogOpen: false,
      likersDialogFileId: null,
      commentCount: 0,
      restoring: false,
      restoreMessage: '',
      restoreFailed: false,
      fileVariations: [],
      variationOverride: null,
      originalText: this.modals.file.original_text || null,
      savingText: false,
      animationDialog: false,
      user: {
        name: '',
      },
    }
  },
  computed: {
    shareAvailable() {
      return !!(this.actions && ['pictures', 'biography'].includes(this.shareSection)
        && canShareRecord(this.modals.file, this.$store.state.user))
    },
    photoToolsAvailable() {
      return !!(this.actions && this.currentImageIsRestorable() && this.currentFileLinkId())
    },
  },
  watch: {
    shareAvailable(value) { if (!value) this.shareOpen = false },
    currentIndex() {
      this.variationOverride = null
    },
  },
  mounted() {
    this.loading = false
    this.user.name = localStorage.getItem('user_name')

    if (!this.$vuetify.breakpoint.mdAndDown) {
      this.textStatus = true
    }

    this.fetchLikeStatus()
    this.fetchFileVariations()
  },
  methods: {
    videoPosterUrl,
    openAnimation() {
      if (this.photoToolsAvailable && !this.restoring) this.animationDialog = true
    },
    onAnimationCreated(animation) {
      this.result = true
      const { file } = this.modals
      if ((file.files_link_ids || []).some(id => Number(id) === Number(animation.fileLinkId))) return
      file.related_files.push(animation.url)
      if (file.files_link_ids) file.files_link_ids.push(animation.fileLinkId)
      if (Array.isArray(file.rotate_position)) file.rotate_position.push(0)
      if (Array.isArray(file.related_posters)) file.related_posters.push(animation.poster)
    },
    closeModal(refresh = false) {
      this.shareOpen = false
      // Close the dialog locally as well as notifying the parent. This keeps
      // the modal from remaining visible if its parent needs a render cycle
      // to remove ModalDetails, and avoids changing the footer layout first.
      this.dialog = false
      this.$emit('closingModal', refresh)
    },
    emitOpenZoom() {
      const currentIdx = this.modals.file.related_files.length > 1 ? this.currentIndex : 0
      const variationData = this.currentVariationData()
      const selectedVariation = this.variationOverride !== null
        ? this.variationOverride
        : (variationData && variationData.variations.some(v => v.is_default) ? 'restored' : 'original')

      this.$emit('openZoom', {
        index: currentIdx,
        url: this.getDisplayUrl(currentIdx),
        variation: selectedVariation,
      })
    },
    currentFileLinkId() {
      const idx = this.modals.file.related_files.length > 1 ? this.currentIndex : 0

      return this.modals.file.files_link_ids ? this.modals.file.files_link_ids[idx] : null
    },
    fileLinkIdAt(index) {
      return this.modals.file.files_link_ids ? this.modals.file.files_link_ids[index] : null
    },
    variationDataAt(index) {
      const linkId = this.fileLinkIdAt(index)
      if (!linkId) return null

      return this.fileVariations.find(fv => fv.files_link_id === linkId) || null
    },
    currentImageIsRestorable() {
      const idx = this.modals.file.related_files.length > 1 ? this.currentIndex : 0
      const url = this.modals.file.related_files[idx]

      return url && this.isImage(url)
    },
    getDisplayUrl(index) {
      const currentIdx = this.modals.file.related_files.length > 1 ? this.currentIndex : 0
      const vData = this.variationDataAt(index)
      if (!vData) {
        return this.modals.file.related_files[index]
      }

      const selectedVariation = index === currentIdx && this.variationOverride !== null
        ? this.variationOverride
        : (vData.variations.some(v => v.is_default) ? 'restored' : 'original')

      if (selectedVariation === 'original') return vData.original_url

      const restored = vData.variations.find(v => v.variation_type === 'restored')

      return restored ? restored.url : this.modals.file.related_files[index]
    },
    selectVariation(type) {
      this.variationOverride = type
      const vData = this.currentVariationData()
      if (vData) {
        this.setDefaultVariation(vData.files_link_id, type === 'restored')
      }
    },
    isVariationSelected(type) {
      const vData = this.currentVariationData()
      if (!vData) return false
      if (this.variationOverride !== null) return this.variationOverride === type
      if (type === 'restored') return vData.variations.some(v => v.is_default)

      return !vData.variations.some(v => v.is_default)
    },
    async fetchFileVariations() {
      if (!this.modals.file || !this.modals.file.id) return
      if (!this.$store.state.jwtToken) return
      try {
        const response = await axios.get(`${this.endpoint}/getFileVariations?file_id=${this.modals.file.id}`, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        if (response.data && response.data.file_links) {
          this.fileVariations = response.data.file_links
        }
      } catch {
        // Silently fail
      }
    },
    currentVariationData() {
      return this.variationDataAt(this.modals.file.related_files.length > 1 ? this.currentIndex : 0)
    },
    async restoreImage() {
      if (this.restoring || !this.photoToolsAvailable) return
      const linkId = this.currentFileLinkId()
      if (!linkId) return

      // Capture which carousel slot initiated the restore. The Replicate call
      // can take a long time; if the user navigates the carousel before it
      // resolves we must NOT flip `variationOverride` on whatever image they're
      // now viewing -- that would visually replace the wrong image.
      const idxAtClick = this.modals.file.related_files.length > 1 ? this.currentIndex : 0
      const fileAtClick = this.modals.file.id

      this.restoring = true
      this.restoreMessage = ''
      this.restoreFailed = false
      try {
        const response = { data: await runAi('restore', { files_link_id: linkId }) }
        if (response.data && response.data.variation) {
          if (this.modals.file.id !== fileAtClick) return
          await this.fetchFileVariations()
          const currentIdx = this.modals.file.related_files.length > 1 ? this.currentIndex : 0
          if (currentIdx === idxAtClick) {
            this.variationOverride = 'restored'
          }

          // Sync the restored URL into the shared modals.file.related_files
          // array so ModalEdit and the parent grid show the new image without
          // requiring the detail modal to be reopened. The grid will get an
          // authoritative refresh from the server when this modal is closed.
          this.syncRelatedFileUrl(linkId)
          this.restoreMessage = t('Image restored. 5 credits used.')
        }
      } catch (error) {
        this.restoreFailed = true
        this.restoreMessage = aiError(error)
      } finally {
        this.restoring = false
      }
    },
    async setDefaultVariation(filesLinkId, isDefault) {
      try {
        await axios.post(`${this.endpoint}/setDefaultVariation`, {
          files_link_id: filesLinkId,
          is_default: isDefault,
        }, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        await this.fetchFileVariations()
        this.syncRelatedFileUrl(filesLinkId)
      } catch {
        // Silently fail
      }
    },

    // Keep modals.file.related_files in sync with the latest variation state
    // for a given files_link_id. Picks the restored URL when a default
    // 'restored' variation exists, otherwise falls back to the original URL.
    syncRelatedFileUrl(filesLinkId) {
      if (!this.modals.file || !this.modals.file.files_link_ids) return
      const idx = this.modals.file.files_link_ids.indexOf(filesLinkId)
      if (idx < 0) return
      const vData = this.fileVariations.find(fv => fv.files_link_id === filesLinkId)
      if (!vData) return
      const restored = vData.variations.find(v => v.variation_type === 'restored' && v.is_default)
      const newUrl = restored ? restored.url : vData.original_url
      if (newUrl && this.modals.file.related_files) {
        this.$set(this.modals.file.related_files, idx, newUrl)
      }
    },
    async fetchLikeStatus() {
      if (!this.modals.file || !this.modals.file.id) return
      try {
        const token = this.$store.state.jwtToken
        if (token) {
          const response = await axios.get(`${this.endpoint}/getLikeStatus?file_ids=${this.modals.file.id}`, {
            headers: { Authorization: token },
          })
          if (response.data) {
            this.isLiked = !!response.data.likeStatus[this.modals.file.id]
            this.likeCount = response.data.likeCounts[this.modals.file.id] || 0
          }
        } else {
          const response = await axios.get(`${this.endpoint}/getLikes?file_id=${this.modals.file.id}`)
          if (response.data) {
            this.likeCount = response.data.likeCount || 0
          }
        }
      } catch {
        // Silently fail
      }
    },
    async toggleLike() {
      if (this.likingInProgress) return
      if (!this.$store.state.jwtToken) return

      this.likingInProgress = true
      try {
        const response = await axios.post(`${this.endpoint}/toggleLike`, {
          file_id: this.modals.file.id,
        }, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        if (response.data) {
          this.isLiked = response.data.liked
          this.likeCount = response.data.likeCount
        }
      } catch {
        // Silently fail
      }
      this.likingInProgress = false
    },
    openLikersDialog() {
      if (this.modals.file && this.modals.file.id) {
        this.likersDialogFileId = this.modals.file.id
        this.likersDialogOpen = true
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    showText() {
      this.textStatus = true
    },
    getSignatureUrl() {
      // console.log('error image');
      // this.$store.commit('getFiles');
      location.reload()
    },
    getCategoryName(id) {
      return this.categoriesName[this.categoriesId.indexOf(parseInt(id, 10))]
    },
    deleteFile() {
      this.deletingFile = true
    },
    formatDate(date) {
      if (!date) return null
      const parsed = new Date(date.length === 10 ? `${date}T12:00:00Z` : date)

      return Number.isNaN(parsed.getTime()) ? date : parsed.toLocaleDateString(this.$locale(), {
        month: 'short', year: 'numeric', day: 'numeric', timeZone: 'UTC',
      })
    },
    submitDelete(id, url) {
      const self = this
      self.loading = true
      axios.post(`${self.endpoint}/deleteFileInfos`, {
        file_id: id,
        filename: url,
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        self.loading = false
        self.result = true
      })
    },
    onAiTextUpdate(newText) {
      this.modals.file.alternative_text = newText
      this.saveTextToBackend()
    },
    async saveTextToBackend() {
      this.savingText = true
      try {
        await axios.post(`${this.endpoint}/updateFileInfos`, {
          name: this.modals.file.name,
          alternative_text: this.modals.file.alternative_text,
          original_text: this.originalText || null,
          category: this.modals.file.categories
            ? this.modals.file.categories.split(', ').map(c => parseInt(c, 10))
            : [],
          tags: [],
          location: this.modals.file.location
            ? JSON.parse(this.modals.file.location)
            : { lat: 0, lng: 0 },
          date: this.modals.file.updated_at.split('T')[0],
          content_type: this.modals.file.content_type,
          file_id: this.modals.file.id,
          public: this.modals.file.public,
          view_type: this.modals.file.view_type,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })
      } catch (err) {
        console.error('Failed to save AI text:', err)
      }
      this.savingText = false
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  padding-top: 0;
}

img {
  height: auto;
  border-radius: 12px;
  width: 100%;
  margin: 0 auto;
  display: block;
  object-fit: contain;
}

.modal-picture-details {
  max-width: 900px !important;
  img {
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .spinner {
    margin: 20px 0 0 -25px;
  }
}
.modal-picture-details .row {
  position: relative;
}

.modal-picture-details .click-region {
  cursor: pointer;
  height: auto;
  position: relative;
  margin-bottom: 20px;

  button:not(.list-video__play) {
    display: block;
    background: none;
    position: absolute;
    // bottom: -48px !important;
    // left: 48%;
    // transform: translateX(-50%);
    z-index: 20;
    right: 0px;
    bottom: 5px;
  }
}

.wrapper-text {
  position: relative;
  padding-top: 0;
  margin-top: 12px;
  width: 100%;
}

.wrapper-copy {
  min-width: 0;
}

.wrapper-buttons-center {
  text-align: center;
  button {
    margin: 0 10px;
  }
}

.rotate-icon {
  position: absolute;
  bottom: -48px !important;
  left: 42% !important;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
}

.inner-text {
  margin-top: 20px;
}

.v-card__actions {
  .close-btn,
  .share-memory {
    // Vuetify's ripple changes static buttons to relative on pointer-down.
    // Keep footer buttons positioned without the old absolute-layout offsets.
    position: relative;
    inset: auto;
  }

  .action-icons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .v-icon {
    margin: 0 8px !important;
    cursor: pointer;
  }
}

.like-action {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  .icon-heart {
    transition: transform 0.2s;

    &.liked {
      animation: likeHeartBeat 0.3s ease;
    }
  }

  .like-count {
    font-size: 13px;
    margin-left: 2px;
    font-weight: 500;
  }
}

.comment-action {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;

  .like-count {
    font-size: 13px;
    font-weight: 500;
  }
}

@keyframes likeHeartBeat {
  0% { transform: scale(1); }
  50% { transform: scale(1.3); }
  100% { transform: scale(1); }
}

.cursor-pointer {
  cursor: pointer;
}

.close-btn,
.black--text,
.share-memory,
.avatar-infos {
  position: absolute;
  right: 20px;
  z-index: 1;
  @media(max-width: 940px) {
    right: 2%;
  }
}

.wrapper-icons {
  position: static;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 36px;
  width: 100%;

  .icon-trash {
    margin-left: 7px !important;
  }
}

.share-memory,
.avatar-infos {
  left: 45px;
  @media(max-width: 940px) {
    left: 2%;
  }
}

.avatar-infos,
.share-memory {
  right: auto;
}

.black--text,
.lnk-read-more {
  right: 37px;
  bottom: 80px;
  @media(max-width: 940px) {
    right: 20px;
  }
}

.lnk-read-more {
  position: absolute;
  right: auto;
}

.memory-bit-banner {
  padding: 12px 20px;
  flex-wrap: wrap;
  gap: 8px;
  .avatar-infos {
    position: static;
  }
  > .v-avatar {
    position: absolute;
  }
}

.dialog-body .black--text,
.dialog-body .lnk-read-more {
  position: static;
}

.text-h5 {
  margin-left: 45px !important;
  margin-bottom: 20px;
}

.txt-date {
  font-size: 18px;
}

.restore-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;

  p {
    font-size: 14px;
    color: #888;
  }
}

.icon-restore {
  float: right;
  margin-left: 7px !important;
  cursor: pointer;
}

.variations-section {
  margin-top: 16px;
  padding: 0 12px;

  .variations-label {
    font-size: 13px;
    font-weight: 500;
    color: #888;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.variations-thumbnails {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.variation-thumb-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.variation-thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

  &:hover {
    border-color: #aaa;
  }
}

.variation-active {
  border-color: var(--v-primary-base, #9155fd) !important;
  box-shadow: 0 0 0 2px rgba(145, 85, 253, 0.25);
}

.variation-thumb-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #666;

  .v-icon {
    cursor: pointer;
  }
}

@media(max-width: 940px) {
  .detail-divider {
    opacity: 0;
  }

}
</style>
